import React, { useState } from 'react';
import {
  Box,
  Divider,
  Grid,
  Heading,
  HStack,
  Tab,
  TabList,
  Tabs,
  Text,
  VStack
} from '@chakra-ui/react';

import ContentLayout from '@layouts/ContentLayout';
import GomsOrdersContent from '@views/Dashboard/GomsOrdersContent';
import BBPSComplaints from './BBPSComplaints';
import { ORDER_TYPE_V2 } from '@constants';
import {
  BBPS_DASHBOARD_TABS,
  BBPS_DASHBOARD_TAB_LABELS,
  BBPS_DASHBOARD_STRINGS
} from './constants';
import { BBPSCategories } from './BBPSCategories';

const BBPSDashboard = () => {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (index) => {
    setActiveTab(index);
  };

  // Get the active tab key
  const activeTabKey = Object.values(BBPS_DASHBOARD_TABS)[activeTab];

  return (
    <ContentLayout>
      <Grid gridTemplateColumns={{ base: '1fr', lg: '7fr 0 3fr' }}>
        <VStack
          overflowY={{ base: 'initial', lg: 'auto' }}
          overflowX={'hidden'}
          h={{ lg: '90vh' }}
          py={10}
          px={{ base: 4, sm: 10 }}
          alignItems={'stretch'}
          className="scroll"
          gap={4}
        >
          {/* Heading */}
          <Heading size="lg" color="colorPrimary">
            {BBPS_DASHBOARD_STRINGS.TITLE}
          </Heading>

          {/* Tabs */}
          <Tabs
            variant={'enclosed'}
            size={'md'}
            onChange={handleTabChange}
            defaultIndex={activeTab}
            width="100%"
          >
            <TabList
              color={'whiteAlpha.700'}
              borderColor={'whiteAlpha.500'}
            >
              {Object.values(BBPS_DASHBOARD_TABS).map((tabKey, index) => (
                <Tab
                  key={tabKey}
                  _selected={{
                    color: 'brand.500',
                    border: '1px solid',
                    borderColor: 'whiteAlpha.500',
                    borderBottom: '1px solid black'
                  }}
                  _focus={{
                    boxShadow: 'none'
                  }}
                >
                  {BBPS_DASHBOARD_TAB_LABELS[tabKey]}
                </Tab>
              ))}
            </TabList>

          </Tabs>

          {/* Tab Content */}
          {activeTabKey === BBPS_DASHBOARD_TABS.ORDERS && (
            <GomsOrdersContent
              defaultOrderType={ORDER_TYPE_V2.BBPS}
              title="Search BBPS Orders"
              placeholder="Search BBPS orders by OrderId"
              showOrderTypeFilter={false}
              autoSearchOnMount={false}
            />
          )}

          {activeTabKey === BBPS_DASHBOARD_TABS.COMPLAINTS && (
            <BBPSComplaints />
          )}

          {activeTabKey === BBPS_DASHBOARD_TABS.CATEGORIES && (
            <BBPSCategories />
          )}

        </VStack>

        <Divider
          style={{ margin: '0' }}
          borderColor="whiteAlpha.300"
          orientation="vertical"
        />

        {/* Right Sidebar - Placeholder for future content */}
        <Box m={0} alignSelf={'flex-start'}>
          <VStack
            py={10}
            px={4}
            alignItems={'stretch'}
            gap={4}
          >
            <Heading size="md" color="white">
              {BBPS_DASHBOARD_STRINGS.QUICK_ACTIONS_TITLE}
            </Heading>
            <Text color="whiteAlpha.600" fontSize="sm">
              {BBPS_DASHBOARD_STRINGS.QUICK_ACTIONS_DESCRIPTION}
            </Text>
          </VStack>
        </Box>
      </Grid>
    </ContentLayout>
  );
};

export default BBPSDashboard;
